import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, CrownIcon, FacebookIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-warm-brown text-cream py-16 border-t border-brand-gold/20" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-81">
          <div className="flex flex-col items-start gap-4" data-id="element-82">
            <div className="flex items-center gap-2" data-id="element-83">
              <CrownIcon className="w-8 h-8 text-brand-gold" data-id="element-84" />
              <span className="font-display italic text-4xl lowercase tracking-wider text-cream" data-id="element-85">
                rozii
              </span>
            </div>
            <span className="font-body text-xs uppercase tracking-[0.2em] text-brand-gold font-bold" data-id="element-86">
              African Hair Braiding
            </span>
            <p className="text-sm text-cream/70 font-display italic mt-2 text-lg" data-id="element-87">
              Crown every woman.
            </p>
          </div>

          <div data-id="element-88">
            <h4 className="font-display text-2xl text-brand-gold mb-6" data-id="element-89">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-4" data-id="element-90">
              {['Home', 'Services', 'About', 'Gallery', 'Contact'].map(link => <Link key={link} to={link === 'Home' ? '/' : `/${link.toLowerCase()}`} className="text-sm uppercase tracking-widest hover:text-brand-gold transition-colors" data-id="element-91">
                    {link}
                  </Link>)}
            </nav>
          </div>

          <div data-id="element-92">
            <h4 className="font-display text-2xl text-brand-gold mb-6" data-id="element-93">
              Contact Info
            </h4>
            <div className="flex flex-col gap-4 text-sm tracking-wide text-cream/80" data-id="element-94">
              <p className="text-brand-gold font-bold uppercase tracking-widest" data-id="element-95">
                Open 24 Hours / 7 Days
              </p>
              <a href="tel:2409217857" className="hover:text-brand-gold transition-colors font-bold text-cream" data-id="element-96">
                (240) 921-7857
              </a>
              <p data-id="element-97">
                7375 Executive Place
                <br data-id="element-98" />
                Suite 214, Lanham MD
              </p>
              <p className="text-brand-gold font-bold mt-2" data-id="element-99">
                $25 Deposit Policy
              </p>
            </div>
          </div>

          <div data-id="element-100">
            <h4 className="font-display text-2xl text-brand-gold mb-6" data-id="element-101">
              Follow Us
            </h4>
            <div className="flex items-center gap-4" data-id="element-102">
              <a href="https://share.google/AnuTHKxIlASaF1Cna" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-cream/10 flex items-center justify-center text-cream hover:bg-brand-gold hover:text-warm-brown transition-colors" aria-label="Google" data-id="element-103">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" data-id="element-104">
                  <path d="M12.48 10.92v3.28h4.74c-.18 1.22-.53 2.1-1.08 2.7-.68.68-1.72 1.44-3.66 1.44-3.12 0-5.62-2.52-5.62-5.64s2.5-5.64 5.62-5.64c1.72 0 3.02.68 3.96 1.58l2.3-2.3C17.14 2.9 15.06 2 12.48 2 7.24 2 3 6.24 3 11.5s4.24 9.5 9.48 9.5c2.84 0 4.98-.94 6.66-2.68 1.72-1.72 2.26-4.14 2.26-6.1 0-.58-.04-1.14-.14-1.66h-8.82z" data-id="element-105" />
                </svg>
              </a>
              <a href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-cream/10 flex items-center justify-center text-cream hover:bg-brand-gold hover:text-warm-brown transition-colors" aria-label="Instagram" data-id="element-106">
                <InstagramIcon className="w-6 h-6" data-id="element-107" />
              </a>
              <a href="https://web.facebook.com/people/Roziiepse-hair-Braiding/61584040603587/#" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-cream/10 flex items-center justify-center text-cream hover:bg-brand-gold hover:text-warm-brown transition-colors" aria-label="Facebook" data-id="element-108">
                <FacebookIcon className="w-6 h-6" data-id="element-109" />
              </a>
              <a href="https://www.tiktok.com/@roziiepse1.11" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-cream/10 flex items-center justify-center text-cream hover:bg-brand-gold hover:text-warm-brown transition-colors" aria-label="TikTok" data-id="element-110">
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-111">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.71a8.21 8.21 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.14z" data-id="element-112" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-cream/10 text-center" data-id="element-113">
          <p className="text-sm text-cream/60 font-body" data-id="element-114">
            &copy; {new Date().getFullYear()} Rozii African Hair Braiding. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}